export default __webpack_public_path__ + "static/media/popup-image.068f2b30.png";